import React, { FunctionComponent, useEffect, useState } from "react";
import ChangePasswordTitle from "./ChangePasswordTitle";
import styles from "./ChangePassword.module.css";
import {
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useForm } from "react-hook-form";
import {
  CustomTextField,
  maxLengthValidation,
  minLengthValidation,
  passwordRegexPattern,
} from "../../../helper";
import images from "../../../assets/images";
import { ApolloError, useMutation } from "@apollo/client";
import { CHANGE_PASSWORD } from "./api/ChangePasswordQuery";
import ToasterWithMessage from "../toaster";

interface ChangePasswordProps {
  handleCloseDialog: () => void;
  setOpenSuccessDialog: (value: boolean) => void;
}
interface submitDataType {
  oldpassword: string,
  newpassword: string,
  retypepassword: string
}
const OldpasswordTextField = CustomTextField();
const NewPasswordTextField = CustomTextField();
const RetypePasswordTextField = CustomTextField();

const ChangePassword: FunctionComponent<ChangePasswordProps> = ({
  handleCloseDialog,
  setOpenSuccessDialog
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: { oldpassword: "", newpassword: "", retypepassword: "" },
    mode: "onTouched",
  });
  const { passwordHideIcon, passwordUnHideIcon } = images;
  const [showOldPassword, setShowOldPassword] = useState<boolean>(false);
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const [showRetypePassword, setShowRetypePassword] = useState<boolean>(false);
  const [mismatchErrorForRetype, setMismatchErrorForRetype] =
    useState<string>("");
  const [mismatchErrorFornewpassword, setMismatchErrorFornewpassword] =
    useState<string>("");
  const { error } = ToasterWithMessage();
  const [passwordErrorForRetype] = useState<string>("New password and retype password are mismatched")

  const handleSubmitData = async (data: submitDataType) => {
    if (mismatchErrorForRetype) {
    } else if (data.newpassword !== data.retypepassword) {
      setMismatchErrorForRetype(
        passwordErrorForRetype
      );
    } else if (data.oldpassword === data.newpassword) {
      setMismatchErrorFornewpassword(
        "Old password and new password should not be same"
      );
    } else {
      setMismatchErrorForRetype("");
      setMismatchErrorFornewpassword("");
      changePassword({
        variables: {
          oldPassword: data.oldpassword,
          newPassword: data.newpassword,
        },
      });
    }
  };

  const [changePassword,{loading}] = useMutation(CHANGE_PASSWORD, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if (data.changePassword.message === "Password updated successfully") {
      reset({ newpassword: "", retypepassword: "", oldpassword: "" });
        handleCloseDialog();
        setOpenSuccessDialog(true);
      }
    },
    onError: (err: ApolloError) => {
    const message = err.message;
    if(message.includes('{"')){
     const errorMessage = JSON.parse(message).message;
    if(errorMessage === 'Incorrect username or password.'){
      error("Old password is not matched");
    }
    }else{
      const errorMsg = message
      error(errorMsg === 'Incorrect username or password.'? 'Old password is not matched' : errorMsg)
    }
    },
  });
  const handleClickShowOldPassword = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowOldPassword((show) => !show);
  };

  const handleClickShowNewPassword = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowNewPassword((show) => !show);
  };

  const handleClickShowRetypePassword = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowRetypePassword((show) => !show);
  };

  const handlechangeOldPassword = (_oldPass: string) => {
    if(errors.oldpassword){
      trigger('oldpassword');
    }
    setMismatchErrorFornewpassword("");
  };

  const handlechangeNewpassword = (newPass: string) => {
    setMismatchErrorFornewpassword("");
    const retypepassword = watch("retypepassword");
    if (
      newPass.length === retypepassword.length &&
      newPass !== retypepassword
    ) {
      setMismatchErrorForRetype(
        passwordErrorForRetype
      );
    } else if (
      retypepassword.length > 0 &&
      (newPass.length > retypepassword.length ||
        newPass.length < retypepassword.length)
    ) {
      setMismatchErrorForRetype(
        passwordErrorForRetype
      );
    } else {
      setMismatchErrorForRetype("");
    }
  };

  const handlechangeRetype = (retypePass: string) => {
    const newpassword = watch("newpassword");
    const retypepassword = retypePass;
    if (newpassword.length > 0 && retypepassword.length > newpassword.length) {
      setMismatchErrorForRetype(
        passwordErrorForRetype
      );
    } else if (
      retypepassword.length === newpassword.length &&
      retypepassword !== newpassword
    ) {
      setMismatchErrorForRetype(
        passwordErrorForRetype
      );
    } else {
      setMismatchErrorForRetype("");
    }
  };

  useEffect(() => {
      handlechangeOldPassword(watch("oldpassword"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[watch("oldpassword")])
  
  useEffect(() => {
    handlechangeNewpassword(watch("newpassword"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[watch("newpassword")])

  useEffect(() => {
    handlechangeRetype(watch("retypepassword"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[watch("retypepassword")])

  return (
    <>
      <form onSubmit={handleSubmit(handleSubmitData)} autoComplete="off">
        <div className={styles.changePassword}>
          <ChangePasswordTitle handlecloseDialog={handleCloseDialog} />
          <div className={styles.textField}>
            <div className={styles.textFieldFullMain}>
              <div className={styles.titlePlaceholder}>
                <div className={styles.newPassword}>Old Password</div>
              </div>
              <OldpasswordTextField
                variant="outlined"
                fullWidth
                type={showOldPassword ? "text" : "password"}
                {...register("oldpassword", {
                  required: "Old password is required!",
                  pattern: {
                    value: passwordRegexPattern,
                    message:
                      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
                  },
                  minLength: minLengthValidation,
                  maxLength: maxLengthValidation
                })}
                placeholder="Enter old password"
                InputProps={{
                  style: {
                    borderRadius: 0,
                    fontFamily: "var(--body-b3-12-semibold-left)",
                    fontSize: "var(--body-b2-14-semibold-left-size)",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowOldPassword}
                        edge="end"
                        disableRipple
                      >
                        {showOldPassword ? (
                           <img
                           className="passwordUnHideIconStyle"
                           src={passwordUnHideIcon}
                           alt="unhideIcon"
                         />
                        ) : (
                          <img src={passwordHideIcon} alt="passwordHideIcon" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={Boolean(errors.oldpassword?.message)}
              />
              <span className={styles.errorMsgStyle}>
                {errors?.oldpassword?.message}
              </span>
            </div>

            <div className={styles.textFieldFullMain}>
              <div className={styles.titlePlaceholder}>
                <div className={styles.newPassword}>New Password</div>
              </div>
              <NewPasswordTextField
                variant="outlined"
                fullWidth
                type={showNewPassword ? "text" : "password"}
                {...register("newpassword", {
                  required: "New password is required!",
                  pattern: {
                    value: passwordRegexPattern,
                    message:
                      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
                  },
                  minLength: minLengthValidation,
                  maxLength: maxLengthValidation
                })}
                placeholder="Enter new password"
                InputProps={{
                  style: {
                    borderRadius: 0,
                    fontFamily: "var(--body-b3-12-semibold-left)",
                    fontSize: "var(--body-b2-14-semibold-left-size)",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowNewPassword}
                        edge="end"
                        disableRipple
                      >
                        {showNewPassword ? (
                          <img
                          className="passwordUnHideIconStyle"
                          src={passwordUnHideIcon}
                          alt="UnHideIcon"
                        />
                        ) : (
                          <img src={passwordHideIcon} alt="HideIcon" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={
                  Boolean(errors.newpassword?.message) ||
                  Boolean(mismatchErrorFornewpassword)
                }
              />
              <span className={styles.errorMsgStyle}>
                {errors?.newpassword?.message || mismatchErrorFornewpassword}
              </span>
            </div>

            <div className={styles.textFieldFullMain}>
              <div className={styles.titlePlaceholder}>
                <div className={styles.newPassword}>Retype Password</div>
              </div>
              <RetypePasswordTextField
                variant="outlined"
                type={showRetypePassword ? "text" : "password"}
                {...register("retypepassword", {
                  required: "Retype Password is required!",
                  minLength: minLengthValidation,
                  maxLength: maxLengthValidation
                })}
                fullWidth
                placeholder={"Enter retype password"}
                InputProps={{
                  style: {
                    borderRadius: 0,
                    fontFamily: "var(--body-b3-12-semibold-left)",
                    fontSize: "var(--body-b2-14-semibold-left-size)",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowRetypePassword}
                        edge="end"
                        disableRipple
                      >
                        {showRetypePassword ? (
                          <img
                            className="passwordUnHideIconStyle"
                            src={passwordUnHideIcon}
                            alt="UnHideIcon"
                          />
                        ) : (
                          <img src={passwordHideIcon} alt="HideIcon" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={
                  Boolean(errors?.retypepassword?.message) ||
                  Boolean(mismatchErrorForRetype)
                }
              />
              <span className={styles.errorMsgStyle}>
                {errors?.retypepassword?.message || mismatchErrorForRetype}
              </span>
            </div>
          </div>
          {
            loading
          ?
            (
              <span className={styles.circularContainer}>
              <div className={styles.submitCircularProgress}>
                <CircularProgress size={20}/>
              </div>
              </span>
            )
          : ''
          }
          <div className={styles.cta}>
            <div className={styles.buttons} onClick={() => reset()}>
              <Button
                classes={{ root: styles.separateStyleforcancel }}
                fullWidth
                disableRipple
              >
                Reset
              </Button>
            </div>
            <div className={loading ? styles.disableBtn : styles.buttons1}>
              <Button
                classes={{ root: styles.separateStyle }}
                disableRipple
                fullWidth
                type="submit"
                disabled ={loading}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ChangePassword;
